import { useRef } from "react";
import styles from "./FileInput.module.scss";

const FileInput = ({ children, onFileSelect, onClick, accept, icon, multiple, Component = 'label', componentProps, ...rest }) => {
  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    // TODO: file validation
    let file = e.target.files[0];

    if (!file) {
      return;
    }

    onFileSelect(multiple ? e.target.files : file);
  };

  const handleClick = (e) => {
    // reset previous file
    fileInputRef.current.value = null;
    onClick?.(e);
  };

  
  return (
    <Component type="button" onClick={handleClick} {...rest} {...componentProps}>
      <input
        ref={fileInputRef}
        type="file"
        onChange={handleChange}
        className={styles.input}
        accept={accept}
        multiple={multiple}
      />
      {icon}
      {children}
    </Component>
  );
};

export default FileInput;
